import { define } from 'wicked-elements'
import Colcade from 'colcade'

define('[data-component~="colcade"]', {
  init() {},
  connected() {
    this.colcade = new Colcade(this.element, {
      columns: '.grid-col',
      items: '.cmoa-grid-item',
    })
  },
  disconnected() {
    this.colcade.destroy()
  },
})
